import { Component } from '@angular/core';

@Component({
    templateUrl: './error-404.component.html',
    styleUrls: ['./error-404.component.min.css'],
})
export class Error404Component {
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/error/error-404.component.ts